import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const WebinarBarchart = ({ data }) => {
  return (
    <div className=" bg-gradient-to-tl from-indigo-200 to-blue-100 rounded w-40 mx-auto">
      <ResponsiveContainer height={200}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis type="number" domain={[0, 100]} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="Score" fill="#00C853" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WebinarBarchart;
